<template>
    <div>
        <div class="show-destop">
            <nav-bar-faq/>
        
            <div id="mainContent" class="container-fluid">
        
                <router-view></router-view>
        
            </div>
        
            <footer-element/>
        </div>
        <mobile-download-app/>
    
    </div>
</template>

<script>
import SideBar from "../SideBar";
import NavBar from "../NavBar";
import FooterElement from "../FooterElement";
import { getConfigs, getLanguage, soundClick } from "../../utils/utils";
import { getPlacementTest, startPlacementTest } from "../../models/placement_test";
import UpgradeAccountModal from "../modal/UpgradeAccountModal";
import { updateLanguage, getParentSettings, updateSetingNofification } from '../../models/profile';
import router from "../../router";
import axios from "axios";
import NavBarFaq from '../NavBarFaq.vue';
import MobileDownloadApp from '../element/MobileDownloadApp.vue';

export default {
    name: "FAQLayout",

    data() {
        const grade_default = localStorage.getItem('grade');
        const configs = getConfigs();
        const localizes = configs.localize || [];

        return {
            locate: getLanguage(),
            locate_obj: null,
            user: {
                grade: 1
            },
            grade_selected: grade_default || 1,
            placement_test: {
                id: 0,
                condition_pass: 0,
                time: 0,
                total_question: 0,
            },
            configs: configs,
            localizes: localizes,
            parent_setting: {},
        };
    },

    components: {
        UpgradeAccountModal,
        FooterElement,
        NavBar,
        SideBar,
        NavBarFaq,
        MobileDownloadApp
    },


    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        user_info() {
            return this.$store.state.user_info;
        }
    },

    mounted() {
        //setInterval(this.refreshData, 2000);
        // this.grade_selected = this.user_info.grade;
        this.grade_selected = localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade;
    },

    created() {
        this.fetch();
    },

    methods: {
        async fetch() {
            const that = this;

            await axios.all([
                getParentSettings()
            ]).then(axios.spread((response) => {
                if (response.data.code != 0) {
                    return;
                }
                that.parent_setting = response.data.results || {};

                console.log(that.parent_setting);
            }));
        },

        refreshData() {
            if (this.$refs.audio) {
                this.$refs.audio.play();

                document.getElementById('footer').click();
            }
        },

        updateSetingNofification(e) {
            const that = this;

            const formData = new FormData();

            formData.append('notification_active', that.parent_setting.notification_active == 'activated' ? 0 : 1);

            that.$store.commit("setLoading", true);

            updateSetingNofification(formData).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    alert(response.data.msg)

                    return;
                }
            }).catch((response) => {
                that.$store.commit("setLoading", false);

                console.error(response)
            });

            e.preventDefault();
        },

        getSoundClick() {
            soundClick();
        },

        confirmSelectGrade() {
            const that = this;

            that.getSoundClick();
            // console.log(this.user_info.placement_test);
            if (this.user_info.student_type != 1 && this.user_info.placement_test == 0) {
                localStorage.setItem('grade', this.grade_selected);
                $('#updateGradeModal').modal("hide");
                window.location.href = '/'
            } else {
                if (this.user_info.grade >= this.grade_selected) {
                    localStorage.setItem('grade', this.grade_selected);
                    // that.$store.commit("setLoading", this.grade_selected);
                    $('#updateGradeModal').modal("hide");
                    // location.reload();
                    window.location.href = '/'
                } else {
                    // const grade_default = localStorage.getItem('grade');
                    //
                    // this.grade_selected = grade_default || 1;

                    that.$store.commit("setLoading", true);
                    // :to="{path: '/lesson/'+subject_id+'-'+units.id+'-'+lesson.id}"
                    const path = '/placement-test/' + that.grade_selected
                    if (this.$route.path !== path) {
                        this.$router.push(path)
                    } else {
                        that.$store.commit("setLoading", false);
                        $('#updateGradeModal').modal("hide");
                    }

                    // this.$router.push({ path: '/placement-test/'+this.grade_selected });
                    // getPlacementTest({
                    //     grade_id: this.grade_selected
                    // }).then((response) => {
                    //     that.$store.commit("setLoading", false);
                    //
                    //     if (response.data.code != 0) {
                    //         return;
                    //     }
                    //
                    //     this.placement_test = response.data.results[0] || {};
                    //
                    //     console.log(this.placement_test)
                    //
                    //     $('#updateGradeModal').modal("hide");
                    //     $('#testPlacementModal').modal();
                    // }).catch(({response}) => {
                    //     that.$store.commit("setLoading", false);
                    //
                    //     console.error(response);
                    // });
                }
            }
        },
        confirmPlacementTest() {
            const that = this;

            that.getSoundClick();

            // if (this.user_info.grade >= this.grade_selected) {
            //     localStorage.setItem('grade', this.grade_selected);
            //     $('#placementModal').modal("hide");
            //     window.location.href = '/'
            // } else {
            that.$store.commit("setLoading", true);
            const path = '/placement-test/' + that.grade_selected
            if (this.$route.path !== path) {
                this.$router.push(path)
                $('#placementModal').modal("hide");
            } else {
                that.$store.commit("setLoading", false);
                $('#placementModal').modal("hide");
            }
            // }
        },
        placementTest() {
            const that = this;

            that.getSoundClick();

            that.$store.commit("setLoading", true);

            startPlacementTest({
                id: this.placement_test.id
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                $('#testPlacementModal').modal("hide");
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },

        selectGrade(grade) {
            this.grade_selected = grade;
        },

        checkGradeSelected(grade) {
            return this.grade_selected == grade;
        },

        onLogout(e) {
            this.$store.dispatch('logout').then(() => {
                window.location.href = "/login";
            });
            e.preventDefault();
        },

        setLocate(e) {
            this.getSoundClick();

            this.locate_obj = e;
            this.locate = e.lang;

            //localStorage.setItem('lang', e);
        },

        updateLocate() {
            const that = this;

            this.getSoundClick();

            localStorage.setItem('lang', this.locate);

            if (that.locate_obj != null) {
                that.$store.commit("setLoading", true);

                updateLanguage({
                    id: that.locate_obj.id,
                    is_raw: true
                }).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        return;
                    }
                }).catch(({ response }) => {
                    that.$store.commit("setLoading", false);

                    console.error(response);
                });
            }

            location.reload();
        }
    }
}
</script>
